import React from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { useGlobal } from '../context/GlobalContext';
import { generateSlug } from '../helper/formatProductData';
import { formatImageUrl } from '../utils/formatImageUrl';

const getCategoryFallbackImage = (value) => {
    switch (value) {
        case 'cold-pressed-oils': return '/assets/images/thumbs/feature-img1.png';
        case 'traditional-sweeteners': return '/assets/images/thumbs/feature-img2.png';
        case 'dairy-products': return '/assets/images/thumbs/feature-img3.png';
        case 'natural-salt': return '/assets/images/thumbs/feature-img4.png';
        case 'family-pack': return '/assets/images/thumbs/feature-img1.png';
        default: return '/assets/images/thumbs/feature-img1.png';
    }
};

const getCategoryImageUrl = (imagePath, fallbackValue) => {
    const fallback = getCategoryFallbackImage(fallbackValue);
    return formatImageUrl(imagePath, fallback);
};

const FeatureOne = () => {
    const { categories } = useGlobal();

    function SampleNextArrow(props) {
        const { onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className="flex-center rounded-circle border border-gray-200 bg-white hover-bg-main-600 hover-text-white transition-1 custom-arrow-btn"
                style={{
                    position: 'absolute', right: '0px', transform: 'translateY(-50%)',
                    zIndex: 2, cursor: 'pointer', boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                    color: '#64748b'
                }}
            >
                <i className="ph ph-caret-right text-lg" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className="flex-center rounded-circle border border-gray-200 bg-white hover-bg-main-600 hover-text-white transition-1 custom-arrow-btn"
                style={{
                    position: 'absolute', left: '0px', transform: 'translateY(-50%)',
                    zIndex: 2, cursor: 'pointer', boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                    color: '#64748b'
                }}
            >
                <i className="ph ph-caret-left text-lg" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        speed: 500,
        cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: { slidesToShow: 6 },
            },
            {
                breakpoint: 1199,
                settings: { slidesToShow: 5 },
            },
            {
                breakpoint: 992,
                settings: { slidesToShow: 4 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 575,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 424,
                settings: { slidesToShow: 2 },
            },
        ],
    };

    // The categories from context
    const categoryData = categories.length > 0 ? categories : [];

    return (
        <div className="feature bg-white" id="featureSection" style={{ padding: '32px 0 16px 0' }}>
            <div className="container container-lg"  >
                <style>{`
                    .custom-category-slider {
                        padding: 0 45px; 
                    }
                    .custom-category-slider .slick-slide {
                        padding: 0 8px;
                    }
                    .custom-category-slider .slick-track {
                        display: flex !important;
                        align-items: flex-start;
                        margin-left: 0;
                        margin-right: 0;
                    }
                    .custom-category-item {
                        text-align: center;
                        margin: 0 auto;
                        display: flex !important;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .custom-category-thumb {
                        width: 100%;
                        max-width: 150px;
                        aspect-ratio: 1;
                        margin: 0 auto;
                        border-radius: 50%;
                        background-color: #eefcf4;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all 0.3s ease;
                        position: relative;
                    }
                    .custom-category-thumb:hover {
                        transform: scale(1.03);
                        box-shadow: 0 4px 12px rgba(41, 158, 96, 0.15);
                    }
                    .custom-arrow-btn {
                        width: 40px;
                        height: 40px;
                        top: 75px;
                    }
                    @media (max-width: 575px) {
                        .custom-category-slider {
                            padding: 0 24px; 
                        }
                        .custom-category-slider .slick-slide {
                            padding: 0 4px;
                        }
                        .custom-arrow-btn {
                            width: 32px;
                            height: 32px;
                            top: 60px;
                        }
                        .custom-category-item h6 {
                            font-size: 0.85rem !important;
                            word-wrap: break-word;
                        }
                        .custom-category-item span.text-xs {
                            font-size: 0.7rem !important;
                        }
                    }
                `}</style>
                <div className="feature-item-wrapper custom-category-slider position-relative wow fadeInUp" data-wow-duration="0.8s">
                    <Slider {...settings}>
                        {
                            categoryData.map((cat, i) => (
                                <div className="custom-category-item wow fadeInUp" data-wow-delay={`${(i % 6) * 0.1}s`} key={cat.id || i}>
                                    <Link to={`/shop/${generateSlug(cat.label)}`} className="custom-category-thumb">
                                        <img
                                            src={getCategoryImageUrl(cat.image, cat.value)}
                                            alt={cat.label}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                padding: '10px'
                                            }}
                                        />
                                    </Link>
                                    <div className="mt-12 text-center w-100">
                                        <h6 className="text-md mb-4" style={{ lineHeight: '1.2' }}>
                                            <Link to={`/shop/${generateSlug(cat.label)}`} className="text-inherit" style={{ color: '#1e293b', fontWeight: '600' }}>
                                                {cat.label}
                                            </Link>
                                        </h6>
                                    </div>
                                </div>
                            ))
                        }
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default FeatureOne
